import React from 'react'

import { Alert } from '@mui/material'

export const FormAlert: React.FC<{
  onClose: () => void
  alertText: string
}> = ({ onClose, alertText }) => {
  return (
    <Alert
      severity="error"
      onClose={onClose}
      sx={{
        borderRadius: '4px',
        color: '#7D1212',
        border: 'solid 1px rgba(170, 0, 0, 0.3)',
      }}
      icon={false}
    >
      {alertText}
    </Alert>
  )
}
